export enum DeleteAccountDialogStepsEnum {
  YOU_SURE = 1,
  WARNING = 2,
  FEEDBACK = 3,
}
